import { render } from "./PostRequest.vue?vue&type=template&id=45d3221b"
import script from "./PostRequest.vue?vue&type=script&lang=js"
export * from "./PostRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__